import { UserAttributeDefs } from "@iotv/datamodel-core";
import { Position, TimedPosition } from "@iotv/iotv-v3-types";
import { EffluentSpreaderHelper } from "../utilityFns";
import { EFFLUENT_PATH_TYPE, EffluentPath } from "./EffluentPath";
import { covertLateralPathToAreaV2 } from "./EffluentSpreader/effluentAreaCalculation";
import { AreaData, EffluentTracker } from "./EffluentTracker";

const typeName = "LateralEffluentSpreader";
const dev = process.env.REACT_APP_DEBUG;
const debug = dev && false;

export class LateralEffluentSpreader extends EffluentTracker {
  // extends DeviceEnabledType<SupportedDevices> implements SubEntities<SpreadingGun> {
  constructor(ob: any) {
    super(ob);
    this.singleDeviceControl = ob.singleDeviceControl || false;
    this.throwDistance = ob.throwDistance;
    this.location = ob.location;
    this.path = ob.path || [];
    this.spreading = ob.spreading;
    this.flow = ob.flow;
    this.span = ob.span;
    this.type = typeName;
  }

  throwDistance: number;
  location?: Position;
  path: TimedPosition[];
  spreading?: boolean;
  flow?: number;
  singleDeviceControl?: boolean;
  span?: number;

  /**
   * Updated relevant runs. Allows runs of type LateralEffluentSpreader
   * @param runList
   * @returns runs of correct run type
   */
  getRelevantRuns(runList: EffluentPath[]): EffluentPath[] {
    debug && console.log("Using lateral specific - getRelevantRuns");
    let filteredRuns = runList.filter(
      (run) => run.pathType === EFFLUENT_PATH_TYPE.LateralEffluentSpreader,
    );
    return filteredRuns;
  }

  /**
   * Function to get the spread LatLngs, and area (m^2), of the raw run
   * @returns LatLngs and area (m^2) obj
   */
  getSpreadOfRawRun(
    relevantRun?: EffluentPath,
    path: Position[] = this.path,
  ): AreaData | undefined {
    debug && console.log("Using lateral specific - getSpreadOfRawRun");

    if (path.length > 1) {
      let mappedPath = path;
      if (relevantRun) {
        mappedPath = this.getPathOnRun(path, relevantRun);
      }

      let positions = covertLateralPathToAreaV2(
        mappedPath,
        this.throwDistance,
        this.span,
        relevantRun,
      );
      if (positions) {
        let turfBoundary =
          EffluentSpreaderHelper.convertPositionToTurf(positions);
        let turfArea = EffluentSpreaderHelper.createArea([turfBoundary]);
        let area = EffluentSpreaderHelper.getAreaMeter(turfArea);
        return { positions, area };
      }
    }
    return undefined;
  }

  // getSpreadOfFilteredRun(relevantRun?: EffluentPath, path: Position[] | undefined = this.mappedPath): AreaData | undefined {
  //   debug && console.log('Should be using default - getSpreadOfMappedRun');
  //   if (path) {
  //     if (path.length > 1) {
  //       // may just call RAW
  //       let positions = covertLateralPathToAreaV2(path, this.throwDistance, this.span, relevantRun);
  //       if (positions) {
  //         let turfBoundary = EffluentSpreaderHelper.convertPositionToTurf(positions);
  //         let turfArea = EffluentSpreaderHelper.createArea([turfBoundary]);
  //         let area = EffluentSpreaderHelper.getAreaMeter(turfArea);
  //         return { positions, area };
  //       }
  //     }
  //   }

  //   return this.getSpreadOfRawRun(relevantRun);
  // }

  getSpreadOfMappedRun(
    relevantRun?: EffluentPath,
    path: Position[] | undefined = this.mappedPath,
  ): AreaData | undefined {
    debug && console.log("Should be using default - getSpreadOfMappedRun");
    if (path) {
      if (path.length > 1) {
        // may just call RAW
        let positions = covertLateralPathToAreaV2(
          path,
          this.throwDistance,
          this.span,
          relevantRun,
        );
        if (positions) {
          let turfBoundary =
            EffluentSpreaderHelper.convertPositionToTurf(positions);
          let turfArea = EffluentSpreaderHelper.createArea([turfBoundary]);
          let area = EffluentSpreaderHelper.getAreaMeter(turfArea);
          return { positions, area };
        }
      }
    }

    return this.getSpreadOfRawRun(relevantRun);
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),

      singleDeviceControl: {
        type: "Boolean",
        editable: true,
        default: false,
        label: "Single Device Control",
        required: true,
      },
      span: {
        type: "Number",
        editable: true,
        label: "Lateral Span Length (m)",
        name: "Lateral Span Length (m)",
        description: "Pivot Span Length (m)",
        required: true,
      },
      location_lat: {
        type: "Number",
        precision: 5,
        editable: false,
        label: "Lateral Lat",
        limits: {
          min: -90,
          max: 90,
        },
        required: false,
      },
      location_lng: {
        type: "Number",
        precision: 5,
        editable: false,
        label: "Lateral Lng",

        limits: {
          min: -180,
          max: 180,
        },
        required: false,
      },
    };
  }
}
